export const colors=["#F26716","#2BD988","#F2A20C","#52A8F2","#F22E2E","#F2E30C","#00000038"]
